module.exports = __webpack_public_path__ + "static/img/main_search_icon_b.6ba6377d.svg";